import { render } from "./termOfValidity.vue?vue&type=template&id=6917cf32&scoped=true"
import script from "./termOfValidity.vue?vue&type=script&lang=js"
export * from "./termOfValidity.vue?vue&type=script&lang=js"

import "./termOfValidity.vue?vue&type=style&index=0&id=6917cf32&scoped=true&lang=css"
import "./termOfValidity.vue?vue&type=style&index=1&id=6917cf32&lang=css"
script.render = render
script.__scopeId = "data-v-6917cf32"

export default script